<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            .cutter-wrp(ref='cutterWrp')
                
                .cutter-cnt
                    .slivers.slivers_top(ref='topSlivers')
                        .sliver-wrp(v-for='item in 40')
                            .sliver
                    .slivers.slivers_bottom(ref='bottomSlivers')
                            .sliver-wrp(v-for='item in 40')
                                .sliver
                    .cutter(ref='cutter')
                        img(src='../../assets/img/animated-scroll/cutter.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';
export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            if (
                !(
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) ||
                    document.documentElement.clientWidth < 768
                )
            )
                this.scrollHandler();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            let bottomSlivers = this.$refs.bottomSlivers.querySelectorAll('.sliver-wrp'),
                topSlivers = this.$refs.topSlivers.querySelectorAll('.sliver-wrp');
            this.timeline
                .fromTo(this.$refs.cutterWrp, {x: '-120%'}, {duration: 4, x: '0%', ease: 'none'}, 0)
                .fromTo(this.$refs.cutter, {rotate: 0}, {duration: 4, rotate: 360, transformOrigin: '50%, 50%', ease: 'none'}, 0);
            if (
                !(
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) ||
                    document.documentElement.clientWidth < 768
                )
            ) {
                this.timeline
                    .fromTo(bottomSlivers, {x: 0, y: 0}, {duration: 4, x: 'random(-1000, -2000)', y: 'random(-80, -70)vh', stagger: {amount: 4}}, 0)
                    .fromTo(topSlivers, {x: 0, y: 0}, {duration: 2, x: 'random(-500, -1000)', y: 'random(70, 80)vh', stagger: {amount: 3}}, 0);
            }
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 200vh;
    position: relative;
    overflow: hidden;
    @media (--viewport-tablet) {
        height: 100vh;
    }
}

.animated-scroll {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--theme);
    @media (--viewport-tablet) {
        position: static !important;
    }
}
.cutter-wrp {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    width: calc(125vw + 25vh);
    position: relative;
    padding-left: 100vw;
}
// .cutter {
//     width: fit-content;
//     margin: auto;
//     img {
//         display: block;
//         margin: auto;
//         width: 40vw;
//         height: auto;
//         margin: auto;
//     }
// }

.cutter {
    width: fit-content;
    margin: auto;
    position: relative;
    z-index: 2;
    &-cnt {
        width: calc(25vw + 25vh);
        position: relative;
        margin-left: auto;
    }
    img {
        position: relative;
    }
}
.slivers {
    position: absolute;
    left: 75%;
    @media (--viewport-tablet) {
        display: none;
    }
    &_top {
        top: 30%;
    }
    &_bottom {
        bottom: 60%;
    }
}
.sliver-wrp {
    .sliver {
        position: absolute;
        top: 50%;
        left: 90%;
        width: 0;
        height: 0;
        z-index: 1;
        border-left: 20px solid #000;
        border: 10px solid transparent;
    }
    &:nth-child(2n) {
        .sliver {
            border: 10px solid transparent;
            border-left: 20px solid #000;
        }
    }
    &:nth-child(3n) {
        .sliver {
            border: 15px solid transparent;
            border-bottom: 15px solid #000;
        }
    }
    &:nth-child(4n) {
        .sliver {
            border: 20px solid transparent;
            border-right: 10px solid #000;
        }
    }
    &:nth-child(5n) {
        .sliver {
            border: 5px solid transparent;
            border-top: 5px solid #000;
        }
    }
    &:nth-child(6n) {
        .sliver {
            border: 10px solid transparent;
            border-left: 20px solid #000;
        }
    }
    &:nth-child(7n) {
        .sliver {
            border: 15px solid transparent;
            border-bottom: 10px solid #000;
        }
    }
    &:nth-child(8n) {
        .sliver {
            border: 20px solid transparent;
            border-right: 5px solid #000;
        }
    }
    &:nth-child(9n) {
        .sliver {
            border: 5px solid transparent;
            border-top: 20px solid #000;
        }
    }
    &:nth-child(10n) {
        .sliver {
            border: 10px solid transparent;
            border-left: 15px solid #000;
        }
    }
}
</style>
